import React, { useState, useEffect } from 'react';
import './Navbar.css';
// Import the logo image
import logo from '../../assets/jsw-logo.png';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="logo-container">
          <img src={logo} alt="JSW" className="navbar-logo" />
          <h1>JSW Studio</h1>
        </div>

        <div className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li className="nav-item" onClick={() => scrollToSection('home')}>主頁</li>
          <li className="nav-item" onClick={() => scrollToSection('about')}>關於我們</li>
          <li className="nav-item" onClick={() => scrollToSection('courses')}>課程</li>
          <li className="nav-item" onClick={() => scrollToSection('trainers')}>教練介紹</li>
          <li className="nav-item" onClick={() => scrollToSection('contact')}>聯絡我們</li>
          <li className="nav-item" onClick={() => scrollToSection('disclaimer')}>免責聲明</li>
          <li className="nav-item" onClick={() => scrollToSection('policy')}>課堂政策</li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
